/** Normalize a JSON-array-string JWT claim (e.g. `custom:clientIds`, `custom:branchIds`) into a string array. */
const parseIdArrayClaim = (raw: unknown): string[] => {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw.filter((id): id is string => typeof id === "string");
  if (typeof raw !== "string") return [];

  try {
    const parsed: unknown = JSON.parse(raw);

    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === "string") : [];
  } catch {
    return [];
  }
};

export const parseClientIdsClaim = parseIdArrayClaim;
export const parseBranchIdsClaim = parseIdArrayClaim;
